import { HashRouter, Routes, Route } from "react-router-dom";
import SimuladorRelayable from "./simulador_relayable";
import SimuladorValoracion from "./simulador_valoracion";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<SimuladorRelayable />} />
        <Route path="/simulador-de-viabilidad" element={<SimuladorRelayable />} />
        <Route path="/calculadora-de-valoracion" element={<SimuladorValoracion />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
